<div class="layout-section" [class.sidebar-to-bottom]="!clockWidget.enabled()" [class.sidebar-collapsed]="nav.collapsed()">
  <app-left-side-bar-v2 />
  <div class="layout-content-seciton u-w-100">
    <!-- <app-header></app-header> -->
    <ng-content #name></ng-content>
  </div>
  <div class="layout-footer">
    <ng-content select="app-alerts-marquee" />
  </div>
  <!-- <app-right-side-bar></app-right-side-bar> -->
</div>
